import React, { useState, useEffect } from 'react';
import { Modal, Form, Button, Alert } from 'react-bootstrap';
import { updateHoliday } from '../../services/api';

const HolidayEditModal = ({ show, onHide, onSuccess, holiday }) => {
    const [formData, setFormData] = useState({
        name: '',
        date: '',
        type: 'fixed',
        isHalfDay: false
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    // Reset form when modal opens/holiday changes
    useEffect(() => {
        if (show && holiday) {
            const holidayDate = new Date(holiday.date).toISOString().split('T')[0];
            setFormData({
                name: holiday.name || '',
                date: holidayDate,
                type: holiday.type || 'fixed',
                isHalfDay: holiday.isHalfDay || false
            });
            setError('');
        }
    }, [show, holiday]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!holiday?._id) {
            setError('Tatil ID bulunamadı');
            return;
        }

        try {
            setLoading(true);
            setError('');

            const response = await updateHoliday(holiday._id, formData);
            if (response.success) {
                onSuccess('Tatil başarıyla güncellendi');
                onHide();
            }
        } catch (error) {
            setError(error.response?.data?.message || 'Tatil güncellenirken hata oluştu');
        } finally {
            setLoading(false);
        }
    };

    const formatTurkishDate = (dateStr) => {
        return new Date(dateStr).toLocaleDateString('tr-TR');
    };

    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>✏️ Tatil Düzenle</Modal.Title>
            </Modal.Header>

            <Form onSubmit={handleSubmit}>
                <Modal.Body>
                    {error && <Alert variant="danger">{error}</Alert>}

                    {/* Mevcut Bilgiler */}
                    {holiday && (
                        <div className="mb-3 p-3 bg-light rounded">
                            <strong>Mevcut:</strong> {holiday.name} - {formatTurkishDate(holiday.date)}
                        </div>
                    )}

                    {/* Tatil Adı */}
                    <Form.Group className="mb-3">
                        <Form.Label>Tatil Adı *</Form.Label>
                        <Form.Control
                            type="text"
                            required
                            value={formData.name}
                            onChange={(e) => setFormData(prev => ({ ...prev, name: e.target.value }))}
                            placeholder="Örn: Şirket Kuruluş Günü"
                        />
                    </Form.Group>

                    {/* Tarih */}
                    <Form.Group className="mb-3">
                        <Form.Label>Tarih *</Form.Label>
                        <Form.Control
                            type="date"
                            required
                            value={formData.date}
                            onChange={(e) => setFormData(prev => ({ ...prev, date: e.target.value }))}
                        />
                    </Form.Group>

                    {/* Tatil Tipi */}
                    <Form.Group className="mb-3">
                        <Form.Label>Tatil Tipi</Form.Label>
                        <Form.Select
                            value={formData.type}
                            onChange={(e) => setFormData(prev => ({ ...prev, type: e.target.value }))}
                        >
                            <option value="fixed">Sabit Tatil</option>
                            <option value="religious">Dini Tatil</option>
                            <option value="half_day">Yarım Gün Tatil</option>
                        </Form.Select>
                    </Form.Group>

                    {/* Yarım Gün Seçeneği */}
                    <Form.Group className="mb-3">
                        <Form.Check
                            type="checkbox"
                            label="Yarım gün tatil"
                            checked={formData.isHalfDay}
                            onChange={(e) => setFormData(prev => ({ ...prev, isHalfDay: e.target.checked }))}
                        />
                        <Form.Text className="text-muted">
                            Bu seçenek working days hesaplamasını etkileyebilir
                        </Form.Text>
                    </Form.Group>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={onHide} disabled={loading}>
                        İptal
                    </Button>
                    <Button type="submit" variant="primary" disabled={loading}>
                        {loading ? 'Güncelleniyor...' : '✏️ Güncelle'}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default HolidayEditModal;